import api from './api';
import { CLOUD_API_URL } from '../config/serverConfig';

export const subscriptionService = {
  getStatus: () => api.get('/api/stripe/subscription-status'),
  createCheckoutSession: (uiMode: string = 'embedded', cadence: string = 'monthly') =>
    api.post('/api/stripe/create-checkout-session', { ui_mode: uiMode, cadence }),
  createPortalSession: () => api.post('/api/stripe/create-portal-session'),
};

function getToken(): string | null {
  try {
    const s = localStorage.getItem('maestro_auth');
    return s ? JSON.parse(s).accessToken : null;
  } catch { return null; }
}

function getUserId(): string | null {
  try {
    const token = getToken();
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.sub || null;
  } catch { return null; }
}

export const billingService = {
  async switchToAnnual(): Promise<{ status: string; current_period_end?: number; error?: string } | null> {
    const token = getToken();
    if (!token) return null;
    try {
      const resp = await fetch(`${CLOUD_API_URL}/api/maestro/billing/switch-to-annual`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      return await resp.json() as any;
    } catch { return null; }
  },

  async switchToMonthly(): Promise<{ status: string; current_period_end?: number; error?: string } | null> {
    const token = getToken();
    if (!token) return null;
    try {
      const resp = await fetch(`${CLOUD_API_URL}/api/maestro/billing/switch-to-monthly`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      return await resp.json() as any;
    } catch { return null; }
  },

  async getStripeSessionUrl(): Promise<string | null> {
    const userId = getUserId();
    const token = getToken();
    if (!userId || !token) return null;
    const resp = await fetch(`${CLOUD_API_URL}/api/maestro/billing/stripe-session?userId=${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!resp.ok) return null;
    const data = await resp.json() as any;
    return data?.url || null;
  },

  async getBillingStatus(): Promise<{ status: string; trial_days_remaining: number } | null> {
    const userId = getUserId();
    const token = getToken();
    if (!userId || !token) return null;
    const resp = await fetch(`${CLOUD_API_URL}/api/maestro/billing/status?userId=${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!resp.ok) return null;
    return await resp.json() as any;
  },

  async cancelAccount(): Promise<boolean> {
    const token = getToken();
    if (!token) return false;
    const resp = await fetch(`${CLOUD_API_URL}/api/stripe/cancel-at-period-end`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
    return resp.ok;
  },
};
